import { CircularProgress, Modal } from "@mui/material";
import PropTypes from "prop-types";

const LoadingState = ({ sx = {}, fixed = false }) => (
  <Modal
    open
    sx={{
      position: fixed ? "fixed" : "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      svg: {
        color: "brightBlue.main",
      },
      maxWidth: "inherit",
      overflow: "hidden",
      left: fixed ? 0 : "auto",
      width: "100%",
      ...sx,
    }}
    slotProps={{
      backdrop: {
        sx: {
          bgcolor: "rgba(255, 255, 255, 0.5)",
          position: "absolute",
        },
      },
    }}
    data-ignore-max-width={fixed || undefined}
    disablePortal
    disableAutoFocus
    disableEscapeKeyDown
  >
    <CircularProgress size="75px" />
  </Modal>
);

LoadingState.propTypes = {
  sx: PropTypes.object,
  fixed: PropTypes.bool,
};

export default LoadingState;
